import { RequestAction } from '@redux-requests/core';
import { gql } from '@redux-requests/graphql';
import { AppsConstants } from 'modules/userApps/store/constants';
import { IAppCountry } from '../actions';

export interface IPricingInfo {
  id: string;
  allowedCountries: IAppCountry[];
}

export const savePricingInfo = ({ id, allowedCountries }: IPricingInfo): RequestAction => ({
  type: AppsConstants.APP_CHANGE_PRICING,
  request: {
    query: gql`
      mutation($id: ID, $allowedCountries: [AppCountryPayload]) {
        saveApp(app: { id: $id, allowedCountries: $allowedCountries }) {
          allowedCountries {
            country
            currencyCode
            activationFeePrice
            hasPayment
            plans {
              name
              monthlyPrice
              description
              usageUnitPrice
              usageMinUnitPrice
              usageMaxUnitPrice
              includedUnits
            }
            trialUnits
            trialDays
            unitDescription
            unitDescriptionPlural
            priceDescription
          }
        }
      }
    `,
    variables: { id, allowedCountries },
  },
  meta: {
    requestKey: id,
    mutations: {
      [AppsConstants.APP + id]: (data, { saveApp }) => {
        if (!saveApp) return data;
        const { allowedCountries } = saveApp || {};
        return {
          ...data,
          allowedCountries,
        };
      },
    },
  },
});
